<template>
  <div :class="{'modal':true, 'show':show}" @click="closeModal">
    <div class="bg-overlay"></div>
    <div class="modal-content">
      <div class="loading" v-show="loading">
        <i class="fa fa-spinner fa-spin fa-fw fa-3x"></i>
        <div>{{ loadingMsg }}</div>
      </div>
      <div class="accepted" v-show="accepted && error === ''">
        <i class="fas fa-clipboard-check fa-5x"></i>
        <div>The schedule reservation/package has been accepted by the driver.</div>
        <button class="button cta success small block" @click="closeModal">Close</button>
      </div>
      <div class="error" v-show="!!error">
        <i class="far fa-times-circle fa-4x"></i>
        <span>{{ error }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'dispatch-schedule',
  computed: {
    show () { return this.$store.state.dispatch.schedule.show },
    loading () { return this.$store.state.dispatch.schedule.loading },
    loadingMsg () { return this.$store.state.dispatch.schedule.loadingMsg },
    accepted () { return this.$store.state.dispatch.schedule.accepted },
    error () { return this.$store.state.dispatch.schedule.error },
  },
  methods: {
    closeModal () {
      if (this.loading) { return }
      this.$store.commit('dispatch/setScheduleShow', false)
      this.$store.commit('dispatch/setScheduleAccepted', false)
      this.$store.commit('dispatch/setScheduleError', '')
    }
  }
}
</script>

<style lang="scss" scoped>
.loading{
  .fa{ color: #5899da; }
  div{
    font-size: 14px;
    color: #555;
    margin-top: 10px;
  }
}

.accepted{
  .fas{ color: #26D97A; }

  div{
    font-size: 14px;
    font-weight: 600;
    color: #555;
    margin: 20px 0 30px;
  }
}

.error{
  color: #f53c3c;

  .far{
    display: block;
    margin-bottom: 5px;
  }
  span{ font-size:14px; }
}

.modal{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0, .5);
  display: none;
  z-index: 12;

  .modal-content{
    position: absolute;
    top: 50%;
    left: 50%;
    width: 400px;
    padding: 25px;
    background: #fff;
    text-align: center;
    border-radius: 6px;
    margin-left: -200px;
    transform: translateY(-50%);
    box-shadow: 1px 1px 5px 2px rgba(0,0,0, .3);
    display: none;

  }
  &.show{
    display: block;

    .modal-content{
      display: block;
      -webkit-animation: slide-down .3s ease-out;
      -moz-animation: slide-down .3s ease-out;
    }
  }
}

@-webkit-keyframes slide-down {
  0% { opacity: 0; -webkit-transform: translateY(100%); }
  100% { opacity: 1; -webkit-transform: translateY(0); }
}
@-moz-keyframes slide-down {
  0% { opacity: 0; -moz-transform: translateY(100%); }
  100% { opacity: 1; -moz-transform: translateY(0); }
}
</style>



// WEBPACK FOOTER //
// src/components/Dispatch/DispatchSchedule.vue